import {Button} from "@cjdev-internal/visual-stack-x/Button";
import * as appConstant from "../../constants/appConstant";
import React from "react";

const AddPlacementButton = ({openModalDialog}) => {
    return (<>
        <Button
            id={"add-placement-button"}
            type="primary"
            onClick={() => openModalDialog(appConstant.PLACEMENT_MODE_CREATE, {})}
        >
            {appConstant.ADD_PLACEMENT.toUpperCase()}
        </Button>
    </>)
}

export default AddPlacementButton;
